// extracted by mini-css-extract-plugin
export var productAvailable = "StockStatus-module--productAvailable--yx0oC";